export const Electron = 1
export const MessagePort = 2
export const ModuleWorker = 3
export const ReferencePort = 4
export const WebSocket = 5
